module.exports = __webpack_public_path__ + "static/media/BreIt.8ba967cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Projects/BreIt.png
// module id = 789
// module chunks = 0